// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/shotlist/v1/delete_shot.proto (package protos.vision.shotlist.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/shotlist/v1/delete_shot.proto.
 */
export const file_vision_shotlist_v1_delete_shot: GenFile = /*@__PURE__*/
  fileDesc("CiR2aXNpb24vc2hvdGxpc3QvdjEvZGVsZXRlX3Nob3QucHJvdG8SGXByb3Rvcy52aXNpb24uc2hvdGxpc3QudjEihwEKEURlbGV0ZVNob3RSZXF1ZXN0EkMKBnBhcmFtcxgBIAEoCzIzLnByb3Rvcy52aXNpb24uc2hvdGxpc3QudjEuRGVsZXRlU2hvdFJlcXVlc3QuUGFyYW1zGi0KBlBhcmFtcxISCgpwcm9qZWN0X2lkGAEgASgJEg8KB3Nob3RfaWQYAiABKAkiZAoSRGVsZXRlU2hvdFJlc3BvbnNlEkQKBnJlc3VsdBgBIAEoCzI0LnByb3Rvcy52aXNpb24uc2hvdGxpc3QudjEuRGVsZXRlU2hvdFJlc3BvbnNlLlJlc3VsdBoICgZSZXN1bHRiBnByb3RvMw");

/**
 * @generated from message protos.vision.shotlist.v1.DeleteShotRequest
 */
export type DeleteShotRequest = Message<"protos.vision.shotlist.v1.DeleteShotRequest"> & {
  /**
   * @generated from field: protos.vision.shotlist.v1.DeleteShotRequest.Params params = 1;
   */
  params?: DeleteShotRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.shotlist.v1.DeleteShotRequest.
 * Use `create(DeleteShotRequestSchema)` to create a new message.
 */
export const DeleteShotRequestSchema: GenMessage<DeleteShotRequest> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_delete_shot, 0);

/**
 * @generated from message protos.vision.shotlist.v1.DeleteShotRequest.Params
 */
export type DeleteShotRequest_Params = Message<"protos.vision.shotlist.v1.DeleteShotRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string shot_id = 2;
   */
  shotId: string;
};

/**
 * Describes the message protos.vision.shotlist.v1.DeleteShotRequest.Params.
 * Use `create(DeleteShotRequest_ParamsSchema)` to create a new message.
 */
export const DeleteShotRequest_ParamsSchema: GenMessage<DeleteShotRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_delete_shot, 0, 0);

/**
 * @generated from message protos.vision.shotlist.v1.DeleteShotResponse
 */
export type DeleteShotResponse = Message<"protos.vision.shotlist.v1.DeleteShotResponse"> & {
  /**
   * @generated from field: protos.vision.shotlist.v1.DeleteShotResponse.Result result = 1;
   */
  result?: DeleteShotResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.shotlist.v1.DeleteShotResponse.
 * Use `create(DeleteShotResponseSchema)` to create a new message.
 */
export const DeleteShotResponseSchema: GenMessage<DeleteShotResponse> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_delete_shot, 1);

/**
 * @generated from message protos.vision.shotlist.v1.DeleteShotResponse.Result
 */
export type DeleteShotResponse_Result = Message<"protos.vision.shotlist.v1.DeleteShotResponse.Result"> & {
};

/**
 * Describes the message protos.vision.shotlist.v1.DeleteShotResponse.Result.
 * Use `create(DeleteShotResponse_ResultSchema)` to create a new message.
 */
export const DeleteShotResponse_ResultSchema: GenMessage<DeleteShotResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_delete_shot, 1, 0);

